import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class ConfigFormValueObject extends ValueObject {
  /**
   * @param {Object}   form
   * @param {String}   form.display
   * @param {ConfigFieldFormVO[]}   form.fields
   * @param {String}   form.id
   * @param {String}   form.type
   * @param {Object}   initialFieldValues
   */

  /**
   * Validate ConfigFormValueObject parameteres
   * @static
   */
  static validate({form, errorFactory} = {}) {
    if (!form.id || !Array.isArray(form.fields)) {
      throw errorFactory(`[ConfigFormValueObject] Bad request parameters`)
    }
  }
}
